import { FC } from 'react'

import { ResourceHeader } from '@factorialco/factorial-one-react/dist/experimental'
import {
  MyTrainingFormHeaderFragment,
  MyTrainingFormMembershipFragment,
} from 'generated/resources/graphql'

import { buildUrl } from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

type Props = {
  form: MyTrainingFormHeaderFragment | undefined
  answers: boolean
  trainingName: string
  target: MyTrainingFormMembershipFragment | undefined | null
}

export const MyTrainingFormHeader: FC<Props> = ({ target, trainingName, answers, form }) => {
  const formType = form?.form?.formType

  return (
    <ResourceHeader
      title={form?.form?.title ?? ''}
      metadata={[
        {
          label: i18n.t('trainings.my_trainings_revamp.surveys.header.title'),
          value: {
            type: 'text',
            content: trainingName,
          },
        },
        formType !== 'satisfaction' && {
          label: i18n.t('trainings.my_trainings_revamp.surveys.header.participant'),
          value: {
            type: 'avatar',
            text: target?.target?.fullName ?? '',
            variant: {
              type: 'person',
              src: buildUrl(target?.target?.avatar) ?? '',
              firstName: target?.target?.firstName ?? '',
              lastName: target?.target?.lastName ?? '',
            },
          },
        },
      ]}
      description={
        form?.form?.formType === 'satisfaction'
          ? i18n.t('trainings.surveys.header.description.satisfaction')
          : i18n.t('trainings.surveys.header.description.effectiveness')
      }
      status={{
        label: '',
        text: answers
          ? i18n.t('trainings.my_trainings_revamp.surveys.header.status.completed')
          : i18n.t('trainings.my_trainings_revamp.surveys.header.status.pending'),
        variant: answers ? 'positive' : 'warning',
      }}
    />
  )
}
